// @TODO cache dos resultados, impedir que saia pela lateral esquerda, definir por html dimensões do translate
var gcDynamicTooltip = {
  debug: false,
  width: 400,
  isResponsive: function (body_width) {
    return body_width < 1024;
  },
  hiddenRight: function (body_width, element_offset) {
    return body_width < gcDynamicTooltip.width +element_offset.left;
  },
  open: function (event) {
    // Cancel leave event while here
    var body_width = $('body').width();
    if (gcDynamicTooltip.isResponsive(body_width)) { return false; }

    var element        = $(this);
    var href           = element.data('tooltip-url');
    var added_class    = element.data('tooltip-class');
    var element_offset = element.offset();
    var offset_top     = element_offset.top - 11;

    if (document.getElementById('gc-dynamic-tooltip') === null) {
    // Adiciona elemento do container
    $('body').append('<div id="gc-dynamic-tooltip" class="gc-dynamic-tooltip ' + added_class + '"></div>');
  }

  element.data('data-tooltip-init', true);
  var ultimos_resultados_container = $('#gc-dynamic-tooltip');
    // @TODO css animations
    ultimos_resultados_container.html('<div class="loader-spin" title="Carregando..."></div>');
    if (gcDynamicTooltip.hiddenRight(body_width, element_offset)) {
      ultimos_resultados_container.css({
        top: offset_top
      }).addClass('gc-dynamic-tooltip-right');
    } else {
      ultimos_resultados_container.removeClass('gc-dynamic-tooltip-right')
      .css({
        top: offset_top,
        left: element_offset.left
      });
    }
    ultimos_resultados_container.addClass('gc-dynamic-tooltip-open');
    ultimos_resultados_container.show(0);
    if (element.data('tooltip-cache')) {
      ultimos_resultados_container.html(element.data('tooltip-cache'));
    } else {
      ultimos_resultados_container.load(href, {}, function () {
        element.data('tooltip-cache', ultimos_resultados_container.html());
      });
    }
    //$.debounce_tooltip_leave.cancel();
  },
  close: function (event) {
    // @TODO css anim
    $('#gc-dynamic-tooltip').removeClass('gc-dynamic-tooltip-open');
    $('#gc-dynamic-tooltip').hide(0);
  }
};